import React from 'react';
import { Link } from 'react-router-dom';

type AppointmentsProps = {
    appointmentsData: any[]
}

const LatestAppointmentResultCard = ({
    appointmentsData
}: AppointmentsProps) => {

    const formatDate = (dateString: string) => {
        if (!dateString) return '---';
        return new Date(dateString).toLocaleDateString("es-ES", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
        }).replace(/\//g, "-");
    };

    const getPatientName = (appointment: any) => {
        return appointment?.metadata?.patient?.name?.toUpperCase() ||
            appointment.patient?.employee?.user?.name?.toUpperCase() ||
            appointment.patient?.candidate?.user?.name?.toUpperCase() ||
            '---';
    };

    const getExamType = (appointment: any) => {
        return appointment?.metadata?.molde?.name ||
            appointment?.metadata?.exam?.name ||
            (appointment?.metadata?.practices?.[0]?.name ?
                `${appointment?.metadata?.practices?.[0]?.name}...` :
                "---");
    };

    return (
        <div className="appointments-results-container">
            {/* Tabla de Últimos Turnos */}
            <div className="appointment-card">
                <div className="card-header">
                    <h6 className="subtitle">Últimos Turnos</h6>
                </div>

                <div className="table-container">
                    <table className="appointments-table">
                        <thead>
                            <tr>
                                <th>Fecha del turno</th>
                                <th>Apellido y Nombre</th>
                                <th>Estado</th>
                            </tr>
                        </thead>
                        <tbody>
                            {appointmentsData?.map((appointment: any) => (
                                <tr key={appointment.id}>
                                    <td data-label="Fecha">
                                        {appointment?.date ? appointment.date : '---'}
                                    </td>
                                    <td data-label="Apellido y Nombre">
                                        {getPatientName(appointment)}
                                    </td>
                                    <td data-label="Estado">
                                        <span className={`status-badge status-${appointment.status?.toLowerCase()}`}>
                                            {appointment.status || '---'}
                                        </span>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

                <div className="card-footer">
                    <Link to="/Turnos?currentTab=Solicitudes" className="card-link">
                        <button className="card-button">
                            Ver todas las solicitudes de Turnos
                        </button>
                    </Link>
                </div>
            </div>

            {/* Tabla de Resultados */}
            <div className="appointment-card">
                <div className="card-header">
                    <h6 className="subtitle">Resultados</h6>
                </div>

                <div className="table-container">
                    <table className="appointments-table">
                        <thead>
                            <tr>
                                <th>Fecha del turno</th>
                                <th>Apellido y Nombre</th>
                                <th>Tipo</th>
                            </tr>
                        </thead>
                        <tbody>
                            {appointmentsData?.filter((appointment: any) => appointment.status?.includes('Finalizado', 'Retirado')).map((appointment: any) => (
                                <tr key={`result-${appointment.id}`}>
                                    <td data-label="Fecha">
                                        {appointment.date}
                                    </td>
                                    <td data-label="Apellido y Nombre">
                                        {getPatientName(appointment)}
                                    </td>
                                    <td data-label="Tipo">
                                        {getExamType(appointment)}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

                <div className="card-footer">
                    <Link to="/Resultados" className="card-link">
                        <button className="card-button">
                            Ver todos los Resultados
                        </button>
                    </Link>
                </div>
            </div>
        </div>
    );
}

export default LatestAppointmentResultCard;